import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import { cloneDeep } from "lodash";
import * as Yup from "yup";
import CoveredEntity from "components/CoveredEntity";
import { ModuleAccess } from "utils/moduleaccess";
import searchicon from "assets/icon/search.svg";
import plus from "assets/icon/plus-icon.svg";
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import ProgramNotes from "assets/icon/ProgramNotes.svg";
import Configurations from "assets/icon/Configurations.svg";

// const validationSchema = Yup.object({
//   coveredEntityName: Yup.string().required("Please select covered entity"),
// });
let ceid = ""

const SearchContainer = ({
  handleUpdateEntity,
  onSearch,
  onManualSearch,
  onReset,
  initialValue,
  handleCEConfigEntity,
  handleCEContract,
  module,
  orgId,
  selectedCEId,
}) => {
  const formikRef = useRef();
  const [isSubmitting, setSubmitting] = useState(true);
  const [isAddPermission, setIsAddPermission] = useState(false);
  const [selectedCE, setSelectedCE] = useState(selectedCEId);
  const [ceList, setCEList] = useState([])
  const [error, setError] = useState(false)
  useEffect(() => {
    ceid = selectedCE
  }, [selectedCE])
  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
    //return (module && module.actions.indexOf(code) != -1)
  };

  useEffect(() => {
    setIsAddPermission(!hasPermission("ADD"));
  }, []);

  const handleSubmit = async (val, actions) => {
    // const { setSubmitting } = actions;
    if (selectedCE == "") {
      setError(true)
      return;
    }
    else {
      setError(false)
    }
    const values = cloneDeep(val);
    await onSearch(values);
    setSubmitting(false);
  };

  const handleCEConfig = async () => {
    let ceId = formikRef.current.values.coveredEntityName;
    if (ceId != "") {
      handleCEConfigEntity(ceId);
    }
  };
  const handleProgram = async () => {
    await onManualSearch();
  };

  const handleCEContractAction = async () => {
    let ceId = formikRef.current.values.coveredEntityName;
    if (ceId != "") {
      handleCEContract(ceId);
    }
  };
  useEffect(() => {
    if (orgId) {
      setSubmitting(true);
    }
    setSelectedCE("")
    setError(false)

  }, [orgId])

  const handleCoverdEntityChange = async (
    value,
    setFieldValue,
    coveredEnty
  ) => {
    window.selectedCoveredEntittyId = value;
    let isDisabled = value == "" ? true : false;
    setSubmitting(isDisabled);
    handleUpdateEntity(coveredEnty);
    setFieldValue("coveredEntityName", value);

    setSelectedCE(value);
    if (ceid) {
      setError(false)
    }
  };
  // useEffect(() => {
  //   setSelectedCE("")
  //   setError(false)

  // }, [orgId])
  useEffect(() => {

  }, [])
  console.log(selectedCE, "selected")
  return (
    <>
      <Formik
        innerRef={formikRef}
        onSubmit={handleSubmit}
        initialValues={initialValue}
        //   validationSchema={validationSchema}
        children={(props) => {
          const { handleSubmit, resetForm, setFieldValue } = props;
          return (
            <div>
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="f-16 text-primary font-weight-700">
                    Search Configurations
                  </h5>
                </div>
                <div>
                  <Button
                    color="primary"
                    className="reset ms-2"
                    hidden={isAddPermission}
                    disabled={isSubmitting}

                    onClick={handleProgram}
                  // disabled={!coveredEntityid}
                  // hidden={!hasPermission("ADD")}
                  >
                    <span className="right_5">
                      <img src={ProgramNotes} alt="" />
                    </span>{" "}
                    Program Notes
                  </Button>
                  <Button
                    color="primary"
                    className="reset ms-2"
                    hidden={isAddPermission}
                    disabled={isSubmitting}
                    onClick={handleCEContractAction}

                  // disabled={!coveredEntityid}
                  // hidden={!hasPermission("ADD")}
                  >
                    <span className="right_5">
                      <img src={plus} alt="" />
                    </span>{" "}
                    Add
                  </Button>
                  <Button
                    color="primary"
                    className="reset ms-2"
                    hidden={isAddPermission}
                    disabled={isSubmitting}
                    onClick={handleCEConfig}

                  // disabled={!coveredEntityid}
                  // hidden={!hasPermission("ADD")}
                  >
                    <span className="right_5">
                      <img src={Configurations} alt="" />
                    </span>{" "}
                    Configurations
                  </Button>
                </div>
              </div>

              <Row md={"auto"}>
                <Col md={3} sm={3} xs={3} lg={3}>
                  {" "}
                  <FormGroup>
                    <Label for="coveredEntityID">Covered Entity</Label>
                    <CoveredEntity
                      value={selectedCE}
                      orgId={orgId}
                      setCEList={setCEList}
                      name="coveredEntityName"
                      onChange={(value, coveredEnty) =>
                        handleCoverdEntityChange(
                          value,
                          setFieldValue,
                          coveredEnty
                        )
                      }
                    />
                    {error == true ? (
                      <div className="text-danger f-12 position-absolute">
                        {"Please select Covered Entity"}
                      </div>
                    ) : null}
                  </FormGroup>
                </Col>
              </Row>
              <Row
                style={{
                  justifyContent: "flex-end",
                  // marginRight: "10px",
                }}
              >
                <Col md="auto" className="">
                  <Label>{""}</Label>
                  <Button
                    onClick={handleSubmit}
                    color="primary"
                    className="search "
                  >
                    <span className="right_5">
                      <img src={search} alt="" />
                    </span>{" "}
                    Search
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      setSubmitting(true);
                      resetForm();
                      onReset();
                      window.selectedCoveredEntittyId = "";
                      setSelectedCE("");
                      setError(false)
                    }}
                    className="reset ms-2"
                  >
                    <span className="right_5">
                      <img src={reseticon} alt="" />
                    </span>{" "}
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </>
  );
};

export default SearchContainer;
